import { initGlobalState, MicroAppStateActions } from "qiankun";
import { consoleDiff, sync2Store, compose, diff } from "./helper";

// State
const DEFAULT_STATE = {
  activeRoute: {},
  headerCartNum: 0,
  msgCount: 0
  // 当前激活的路由path
};

// Actions
let actions: MicroAppStateActions;

// 注意compose是从后往前执行的
const listeners = compose(
  // 同步到store
  sync2Store("root/UPDATE_GLOBAL_STATES"),

  // 输出到控制台
  consoleDiff
);

// Init qiankun global state
export function initGlobalStates() {
  actions = initGlobalState({ ...DEFAULT_STATE });

  actions.onGlobalStateChange(function (state, prevState) {
    const changeKeys = diff(state, prevState);

    if (!changeKeys.length) return;
    // console.log(changeKeys, "--changeKeys");

    listeners({ changeKeys, state, prevState });
  });

  // 初始化时将状态同步到store
  sync2Store("root/UPDATE_GLOBAL_STATES")({
    changeKeys: Object.keys(DEFAULT_STATE),
    state: DEFAULT_STATE
  });
}

export const getActions = () => actions;
